import { isEqual } from "date-fns";

import { IAgent } from "store/entities/agents";
import { CannedResponseAuthor, ICannedResponse } from "store/entities/canned-responses";
import { removeDuplicates } from "utils/array";

export function cannedResponseWasUpdated(cannedResponse: ICannedResponse): boolean {
  return !isEqual(cannedResponse.createdAt, cannedResponse.updatedAt);
}

export function getCannedResponseAuthorType(cannedResponse: ICannedResponse): CannedResponseAuthor {
  if (cannedResponseWasUpdated(cannedResponse)) {
    return "agent";
  }

  return cannedResponse.createdByType;
}

export function getCannedResponseAuthorName(cannedResponse: ICannedResponse, agents: IAgent[]): string | null {
  const agentId = cannedResponse.updatedBy || cannedResponse.createdBy;
  const agent = agents.find(agentItem => agentItem.id === agentId);
  return agent ? agent.name : null;
}

export function parseShortcuts(shortcuts: string): string[] {
  return removeDuplicates(
    shortcuts
      .split(",")
      .map((shortcut: string) => shortcut.trim().replace(/^#/, "").substring(0, 70))
      .filter(Boolean)
  );
}

export function areShortcutValid(cannedResponseShortcuts: string): boolean {
  return parseShortcuts(cannedResponseShortcuts).length > 0;
}
